<div class="row">
  <div class="col-12">
    <div class="p-4">
      <dynamic-form *ngIf="formBuscarStock" [fields]="formBuscarStock" header="<b>Buscar stock</b>"
        (submit)="buscar($event)">
      </dynamic-form>
    </div>
  </div>
</div>
<div class="row" *ngIf="stocks">
  <div class="col-12">
    <div class="p-4">
      <div class="row mb-2">
        <div class="col-12 text-white">
          <b>Resultados</b>
        </div>
      </div>
      <div class="row" *ngIf="totalStock !== 0">
        <div class="col-12 text-white">
          Total de Unidades en Stock: {{ totalStock}}
        </div>
      </div>
      <div class="row" *ngFor="let stock of stocks">
        <div class="col-12 py-2 border-bottom  text-white">
          {{stock.display}}
          <button class="btn btn-sm btn-link m-0" (click)="seleccionarStock(stock)">Seleccionar</button>
        </div>
      </div>
    </div>
  </div>
</div>
